var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "tile is-child box has-sticky-tile",
      staticStyle: { "margin-bottom": "1rem !important" },
    },
    [
      _c(
        "div",
        {
          staticClass: "is-flex is-align-items-center",
          staticStyle: { height: "60px" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "toggle-buttons-vertical ml-2 is-flex is-flex-direction-column mt-2 mb-1",
            },
            [
              _c(
                "span",
                {
                  staticClass: "button m-0",
                  class: {
                    "is-primary is-selected": _vm.innerValue.jobInOut === 0,
                  },
                  staticStyle: { "border-radius": "5px 5px 0px 0px" },
                  on: {
                    click: function ($event) {
                      return _vm.changeInOut(0)
                    },
                  },
                },
                [_c("span", [_vm._v("Due In Report")])]
              ),
              _c(
                "span",
                {
                  staticClass: "button m-0",
                  class: {
                    "is-primary is-selected": _vm.innerValue.jobInOut === 1,
                  },
                  staticStyle: { "border-radius": "0px 0px 5px 5px" },
                  on: {
                    click: function ($event) {
                      return _vm.changeInOut(1)
                    },
                  },
                },
                [_c("span", [_vm._v("Due Out Report")])]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "ml-2 is-flex is-flex-direction-column mb-1",
              staticStyle: { height: "100%" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "field m-0 is-flex is-align-items-end mb-4",
                  staticStyle: { height: "50%" },
                },
                [
                  _c("div", { staticClass: "control" }, [
                    _c("div", { staticClass: "select is-small" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.innerValue.selectDateType,
                              expression: "innerValue.selectDateType",
                            },
                          ],
                          staticClass: "has-text-weight-bold",
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.innerValue,
                                "selectDateType",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "today" } }, [
                            _vm._v("Today"),
                          ]),
                          _c("option", { attrs: { value: "tomorrow" } }, [
                            _vm._v("Tomorrow"),
                          ]),
                          _c("option", { attrs: { value: "next7days" } }, [
                            _vm._v("Next 7 days"),
                          ]),
                          _c("option", { attrs: { value: "lastweek" } }, [
                            _vm._v("Last Week"),
                          ]),
                          _c("option", { attrs: { value: "thismonth" } }, [
                            _vm._v("This Month"),
                          ]),
                          _c("option", { attrs: { value: "custom" } }, [
                            _vm._v("Custom"),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "field is-flex is-flex-direction-row is-align-items-center",
                  staticStyle: { height: "50%" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "control" },
                    [
                      _c("v-date-picker", {
                        ref: "datepicker",
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "model-config": _vm.selectedFromDate
                            ? {}
                            : _vm.modelConfig,
                          "max-date": _vm.selectedToDate,
                          timezone: _vm.$filters.getIanaTimezone(),
                        },
                        on: { input: _vm.getData },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c("div", { staticClass: "field" }, [
                                  _c(
                                    "div",
                                    { staticClass: "control has-icons-left" },
                                    [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  theme: "danger",
                                                  enabled:
                                                    _vm.$v.filter.dateFrom
                                                      .$error,
                                                },
                                                expression:
                                                  "{ theme: 'danger', enabled: $v.filter.dateFrom.$error }",
                                              },
                                            ],
                                            staticClass: "input is-small",
                                            class: {
                                              "is-danger":
                                                _vm.$v.filter.dateFrom.$error,
                                            },
                                            attrs: {
                                              type: "text",
                                              placeholder: "Date From...",
                                              content: "Date is required",
                                            },
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-small is-left",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-calendar mdi-18px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.selectedFromDate,
                          callback: function ($$v) {
                            _vm.selectedFromDate = $$v
                          },
                          expression: "selectedFromDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._m(0),
                  _c(
                    "div",
                    [
                      _c("v-date-picker", {
                        ref: "datepicker",
                        staticClass: "is-fullwidth",
                        attrs: {
                          "is-dark": _vm.$theme.isDark,
                          masks: _vm.formats,
                          attributes: _vm.attrs,
                          locale: _vm.$userInfo.locale,
                          "model-config": _vm.selectedToDate
                            ? {}
                            : _vm.modelConfig,
                          "min-date": _vm.selectedFromDate,
                          timezone: _vm.$filters.getIanaTimezone(),
                        },
                        on: { input: _vm.getData },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function ({ inputValue, inputEvents }) {
                              return [
                                _c("div", { staticClass: "field" }, [
                                  _c(
                                    "div",
                                    { staticClass: "control has-icons-left" },
                                    [
                                      _c(
                                        "input",
                                        _vm._g(
                                          {
                                            directives: [
                                              {
                                                name: "tippy",
                                                rawName: "v-tippy",
                                                value: {
                                                  theme: "danger",
                                                  enabled:
                                                    _vm.$v.filter.dateTo.$error,
                                                },
                                                expression:
                                                  "{ theme: 'danger', enabled: $v.filter.dateTo.$error }",
                                              },
                                            ],
                                            staticClass: "input is-small",
                                            class: {
                                              "is-danger":
                                                _vm.$v.filter.dateTo.$error,
                                            },
                                            attrs: {
                                              type: "text",
                                              placeholder: "Date To...",
                                              content: "Date is required",
                                            },
                                            domProps: { value: inputValue },
                                          },
                                          inputEvents
                                        )
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "icon is-small is-left",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "mdi mdi-calendar mdi-18px",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.selectedToDate,
                          callback: function ($$v) {
                            _vm.selectedToDate = $$v
                          },
                          expression: "selectedToDate",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "is-flex is-flex-direction-row is-justify-content-space-evenly",
              staticStyle: { height: "60px", width: "100%" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-flex-direction-column is-align-items-center",
                },
                [
                  _c("span", { staticClass: "mt-1 header-text-divider" }, [
                    _vm._v("Total Jobs"),
                  ]),
                  !_vm.isLoading
                    ? _c(
                        "span",
                        { staticClass: "is-size-4 has-text-weight-bold" },
                        [_vm._v(_vm._s(_vm.totalJobs))]
                      )
                    : _c("div", { staticClass: "spins" }, [
                        _c("span", { staticClass: "mdi mdi-loading" }),
                      ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "is-flex is-flex-direction-column is-align-items-center",
                },
                [
                  _c("span", { staticClass: "mt-1 header-text-divider" }, [
                    _vm._v(
                      _vm._s(
                        _vm.innerValue.jobInOut === 0
                          ? "Amount Booked"
                          : "Total Jobs Amount"
                      )
                    ),
                  ]),
                  !_vm.isLoading
                    ? _c(
                        "span",
                        { staticClass: "is-size-4 has-text-weight-bold" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.amountBooked,
                                this.$userInfo.locale
                              )
                            )
                          ),
                        ]
                      )
                    : _c("div", { staticClass: "spins" }, [
                        _c("span", { staticClass: "mdi mdi-loading" }),
                      ]),
                ]
              ),
              _vm.innerValue.jobInOut === 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Avg Daily Amount"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [_vm._v(_vm._s(_vm.avgDailyAmount))]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  )
                : _vm._e(),
              _vm.innerValue.jobInOut === 1
                ? _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-flex-direction-column is-align-items-center",
                    },
                    [
                      _c("span", { staticClass: "mt-1 header-text-divider" }, [
                        _vm._v("Completed Amount"),
                      ]),
                      !_vm.isLoading
                        ? _c(
                            "span",
                            { staticClass: "is-size-4 has-text-weight-bold" },
                            [_vm._v(_vm._s(_vm.amountCompleted))]
                          )
                        : _c("div", { staticClass: "spins" }, [
                            _c("span", { staticClass: "mdi mdi-loading" }),
                          ]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "field mr-2 ml-2" }, [
      _c("span", { staticClass: "icon" }, [
        _c("i", { staticClass: "mdi mdi-arrow-right" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }